import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { createGlobalStyle } from 'styled-components';
import { RadiodataFontFace } from './font';
import u from './utils';
import t from './theme';
export var RatiodataFont = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), RadiodataFontFace);
export var StyledIcon = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: 'Ratiodata Icons';\n  \n  font-size: ", ";\n  color: ", ";\n\n  :hover {\n    cursor: ", ";\n  }\n"])), u.getIconSize, function (props) {
  return props.isDisabled ? t.getDisabledIconAppereance : t.getDefaultIconAppearance;
}, function (props) {
  return props.isDisabled ? 'not-allowed' : 'pointer';
});